module.exports = __webpack_public_path__ + "static/media/orange-doodle.c15f90ef.jpg";